/** Every `type` the switch in FieldRow renders. A catalog field outside this set would show "Unsupported field type". */
export const FIELD_TYPES = new Set([
  'text', 'password', 'number', 'checkbox', 'schedule', 'select', 'multiline', 'expression', 'code', 'sql', 'lines', 'kv',
  'assignments', 'time_window', 'credential', 'slack_channel', 'slack_user', 'slack_users', 'slack_message', 'slack_file',
  'slack_usergroup', 'slack_emoji', 'slack_workspace_status', 'linear_workspace_status', 'linear_team', 'linear_state',
  'linear_assignee', 'linear_priority', 'linear_sub_issues', 'additional_fields', 'mcp_credential', 'mcp_tools',
  'agent_model', 'agent_tools', 'alert_multi_picker', 'entity_filters',
  'decision_model', 'decision_state', 'decision_questions', 'decision_abstain', 'decision_routes',
  'dataset_picker',
]);

